module.exports = __webpack_public_path__ + "media/31.cb9715fe.mp3";